export const MEETING_STATUS_COLOR = {
  initial: 'grey',
  approved: 'green',
  declined: 'red',
  hold: 'blue',
  done: 'grey'
};
